<template>
    <div id="task-filter-bar">
        <div class="filter-section">
            <div class="filter-toolbar">
                <div class="search-bar">
                    <a-input
                        v-model="localSearchQuery"
                        placeholder="Görevlerde ara..."
                        @keyup.enter="handleSearch"
                        class="modern-search-input"
                        ref="searchInput"
                    >
                        <template #prefix>
                            <span class="material-icons search-icon">search</span>
                        </template>
                    </a-input>
                </div>
                <div class="avatar-content" style="display: flex; align-items: center">
                    <div
                        @click="toggleUserSelection('notAppointed')"
                        :style="{
                            border: isUserSelected('notAppointed') ? '2px solid #47499d' : '2px solid #e8e8e8',
                            borderRadius: '50%',
                            marginRight: '8px',
                            backgroundColor: 'white',
                            zIndex: isUserSelected('notAppointed') ? '10' : '5'
                        }"
                        :class="['avatar-container', {'selected': isUserSelected('notAppointed')}]"
                    >
                        <Avatar
                            style="cursor: pointer"
                            :size="30"
                            :key="1"
                            :username="$t('message.notAppointed')"
                            :src="'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp'"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('message.notAppointed')"
                        />
                    </div>
                    <div v-for="(user, index) in visibleUsers" :key="user._id" class="avatar-wrapper">
                        <div
                            @click="toggleUserSelection(user._id)"
                            :style="{
                                border: isUserSelected(user._id) ? '2px solid #47499d' : '2px solid white',
                                borderRadius: '50%',
                                marginLeft: index > 0 ? '-8px' : '0px',
                                zIndex: isUserSelected(user._id) ? 10 : (5 - index),
                                backgroundColor: 'white'
                            }"
                            :class="['avatar-container', {'selected': isUserSelected(user._id)}]"
                        >
                            <Avatar
                                style="cursor: pointer"
                                :size="30"
                                :key="1"
                                :username="user.name"
                                :src="user.gravatar"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="user.name"
                            />
                        </div>
                    </div>
                    <div v-if="remainingUsers.length > 0" class="custom-dropdown-container">
                        <div
                            class="avatar-container remaining-indicator"
                            :class="{'active': isRemainingUsersOpen}"
                            @click="toggleRemainingUsers"
                            :style="{
                                border: 'none',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '34px',
                                height: '34px',
                                cursor: 'pointer',
                                backgroundColor: '#47499d',
                                color: 'white',
                                fontSize: '14px',
                                marginLeft: '-8px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                zIndex: '1'
                            }"
                        >
                            +{{ remainingUsers.length }}
                        </div>

                        <div v-if="isRemainingUsersOpen" class="custom-dropdown" ref="customDropdown">
                            <div class="dropdown-arrow"></div>
                            <div class="dropdown-header">
                                <div class="dropdown-header-top">
                                    <span>Diğer Kullanıcılar</span>
                                    <span class="dropdown-close" @click="closeRemainingUsers">
                                        <span class="material-icons">close</span>
                                    </span>
                                </div>
                                <div class="dropdown-search">
                                    <a-input
                                        v-model="remainingUsersSearchQuery"
                                        placeholder="Kullanıcı ara..."
                                        class="dropdown-search-input"
                                    >
                                        <template #prefix>
                                            <span class="material-icons search-icon">search</span>
                                        </template>
                                    </a-input>
                                </div>
                            </div>
                            <div class="dropdown-content">
                                <div
                                    v-for="user in filteredRemainingUsers"
                                    :key="user._id"
                                    class="dropdown-item"
                                    @click="toggleUserSelection(user._id)"
                                >
                                    <div
                                        :style="{
                                            border: isUserSelected(user._id) ? '2px solid #47499d' : '2px solid #e8e8e8',
                                            borderRadius: '50%',
                                            backgroundColor: 'white'
                                        }"
                                        :class="['avatar-container', {'selected': isUserSelected(user._id)}]"
                                    >
                                        <Avatar
                                            style="cursor: pointer"
                                            :size="30"
                                            :key="1"
                                            :username="user.name"
                                            :src="user.gravatar"
                                        />
                                    </div>
                                    <div class="dropdown-item-name">
                                        {{ user.name }}
                                    </div>
                                    <div class="dropdown-item-check" v-if="isUserSelected(user._id)">
                                        <span class="material-icons">check</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Yeni filtre butonu -->
                <div class="filter-button">
                    <a-button
                        :class="['custom-filter-button', { 'active-filter': isFilterModalOpen || activeFilterCount > 0 }]"
                        @click="toggleFilterModal"
                        v-tippy="{
                            content: 'Filtrele',
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                    >
                        <span class="material-icons" style="font-size: 18px">filter_list</span>
                        <span class="button-text">Filtrele{{ activeFilterCount > 0 ? ` (${activeFilterCount})` : '' }}</span>
                        <span class="filter-indicator" v-if="isFilterModalOpen"></span>
                    </a-button>

                    <!-- Filtre panel içeriği -->
                    <div class="filter-panel" v-if="isFilterModalOpen" ref="filterPanel">
                        <div class="filter-panel-arrow"></div>
                        <div class="filter-panel-content">
                            <div class="filter-header">
                                <h3>Filtrele</h3>
                                <div class="filter-header-actions">
                                    <a-button type="link" @click="resetFilters" class="reset-button">Filtreleri temizle</a-button>
                                    <a-button type="primary" @click="applyFilters" class="apply-button">Uygula</a-button>
                                    <a-button type="link" icon="close" @click="closeFilterModal" class="close-button" />
                                </div>
                            </div>

                            <div class="filter-tab-layout">
                                <!-- Sol tab menü -->
                                <div class="filter-tabs">
                                    <div
                                        v-for="tab in filterTabs"
                                        :key="tab.key"
                                        :class="['filter-tab', { 'active': activeFilterTab === tab.key }]"
                                        @click="activeFilterTab = tab.key"
                                    >
                                        {{ tab.title }}
                                        <span v-if="hasActiveFilterInTab(tab.key)" class="tab-filter-indicator"></span>
                                    </div>
                                </div>

                                <div class="filter-tab-content">
                                    <!-- Öncelik -->
                                    <div v-show="activeFilterTab === 'priorities'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="priority-info">
                                                <h4>Görev Önceliği Seçimi</h4>
                                                <p class="priority-description-text">
                                                    Görevlerin öncelik seviyesine göre filtreleme yapabilirsiniz.
                                                    İstediğiniz öncelik seviyelerini seçerek görevleri filtreleyebilirsiniz.
                                                </p>
                                            </div>

                                            <div class="priority-selection">
                                                <div v-for="priority in priorities" :key="priority.value"
                                                    class="priority-card"
                                                    @click="togglePriorityInPanel(priority.value, !localSelectedPriorities.includes(priority.value))">
                                                    <div class="priority-card-header"
                                                        :class="{'selected': localSelectedPriorities.includes(priority.value)}">
                                                        <component :is="priority.icon" class="priority-icon" />
                                                        <div class="priority-label">{{ priority.label }}</div>
                                                        <a-checkbox
                                                            :checked="localSelectedPriorities.includes(priority.value)"
                                                            @click.stop
                                                            @change="e => togglePriorityInPanel(priority.value, e.target.checked)"
                                                            class="priority-checkbox"
                                                        />
                                                    </div>
                                                    <div class="priority-card-body">
                                                        <p class="priority-description">{{ priority.description }}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="priority-info-card">
                                                <div class="priority-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Öncelik Seviyeleri Hakkında</span>
                                                </div>
                                                <p class="priority-info-text">
                                                    Öncelik seviyeleri, görevlerin önem derecesini belirtir.
                                                    Yüksek öncelikli görevler ekibinizin daha önce odaklanması gereken işleri gösterirken,
                                                    düşük öncelikli görevler daha az aciliyet gerektiren işleri belirtir.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Göreve Atanan -->
                                    <div v-show="activeFilterTab === 'assignees'" class="filter-tab-pane">
                                        <div class="filter-options assignee-options">
                                            <div class="assignees-info">
                                                <h4>Kullanıcı Seçimi</h4>
                                                <p class="assignees-description">
                                                    Göreve atanan kullanıcılara göre filtreleme yapabilirsiniz.
                                                    İstediğiniz kullanıcıları seçerek, sadece onlara atanan görevleri görebilirsiniz.
                                                </p>
                                            </div>

                                            <div class="assignees-selection">
                                                <div class="assignee-container">
                                                    <div
                                                        @click="toggleUserSelectionInPanel('notAppointed')"
                                                        :style="{
                                                            border: isUserSelected('notAppointed') ? '2px solid #47499d' : '2px solid #e8e8e8',
                                                            borderRadius: '50%',
                                                            backgroundColor: 'white',
                                                            zIndex: isUserSelected('notAppointed') ? '10' : '5'
                                                        }"
                                                        :class="['avatar-container', {'selected': isUserSelected('notAppointed')}]"
                                                    >
                                                        <Avatar
                                                            style="cursor: pointer"
                                                            :size="40"
                                                            :key="1"
                                                            :username="$t('message.notAppointed')"
                                                            :src="'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp'"
                                                            v-tippy="{
                                                                followCursor: true,
                                                                placement: 'bottom-end',
                                                            }"
                                                            :content="$t('message.notAppointed')"
                                                        />
                                                    </div>
                                                    <div class="assignee-name">
                                                        Atanmamış
                                                    </div>
                                                </div>

                                                <div v-for="user in filteredUsersAvatar" :key="user._id" class="assignee-container">
                                                    <div
                                                        @click="toggleUserSelectionInPanel(user._id)"
                                                        :style="{
                                                            border: isUserSelected(user._id) ? '2px solid #47499d' : '2px solid white',
                                                            borderRadius: '50%',
                                                            backgroundColor: 'white',
                                                            zIndex: isUserSelected(user._id) ? 10 : 5
                                                        }"
                                                        :class="['avatar-container', {'selected': isUserSelected(user._id)}]"
                                                    >
                                                        <Avatar
                                                            style="cursor: pointer"
                                                            :size="40"
                                                            :key="1"
                                                            :username="user.name"
                                                            :src="user.gravatar"
                                                            v-tippy="{
                                                                followCursor: true,
                                                                placement: 'bottom-end',
                                                            }"
                                                            :content="user.name"
                                                        />
                                                    </div>
                                                    <div class="assignee-name">
                                                        {{ user.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Görev Sahibi -->
                                    <div v-show="activeFilterTab === 'owners'" class="filter-tab-pane">
                                        <div class="filter-options assignee-options">
                                            <div class="assignees-info">
                                                <h4>Görev Sahibi Seçimi</h4>
                                                <p class="assignees-description">
                                                    Görev sahiplerine göre filtreleme yapabilirsiniz.
                                                    İstediğiniz kullanıcıları seçerek, sadece onların sahip olduğu görevleri görebilirsiniz.
                                                </p>
                                            </div>

                                            <div class="owner-search">
                                                <a-input
                                                    v-model="ownerSearchQuery"
                                                    placeholder="Görev sahibi ara..."
                                                    class="owner-search-input"
                                                >
                                                    <template #prefix>
                                                        <span class="material-icons search-icon">search</span>
                                                    </template>
                                                </a-input>
                                            </div>

                                            <div class="assignees-selection">
                                                <div v-for="user in filteredOwnerUsers" :key="user._id" class="assignee-container">
                                                    <div
                                                        @click="toggleOwnerSelection(user._id)"
                                                        :style="{
                                                            border: isOwnerSelected(user._id) ? '2px solid #47499d' : '2px solid white',
                                                            borderRadius: '50%',
                                                            backgroundColor: 'white',
                                                            zIndex: isOwnerSelected(user._id) ? 10 : 5
                                                        }"
                                                        :class="['avatar-container', {'selected': isOwnerSelected(user._id)}]"
                                                    >
                                                        <Avatar
                                                            style="cursor: pointer"
                                                            :size="40"
                                                            :key="1"
                                                            :username="user.name"
                                                            :src="user.gravatar"
                                                            v-tippy="{
                                                                followCursor: true,
                                                                placement: 'bottom-end',
                                                            }"
                                                            :content="user.name"
                                                        />
                                                    </div>
                                                    <div class="assignee-name">
                                                        {{ user.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Görev Takipçileri -->
                                    <div v-show="activeFilterTab === 'followers'" class="filter-tab-pane">
                                        <div class="filter-options assignee-options">
                                            <div class="assignees-info">
                                                <h4>Görev Takipçileri Seçimi</h4>
                                                <p class="assignees-description">
                                                    Görev takipçilerine göre filtreleme yapabilirsiniz.
                                                    İstediğiniz kullanıcıları seçerek, sadece takip ettikleri görevleri görebilirsiniz.
                                                </p>
                                            </div>

                                            <div class="follower-search">
                                                <a-input
                                                    v-model="followerSearchQuery"
                                                    placeholder="Takipçi ara..."
                                                    class="follower-search-input"
                                                >
                                                    <template #prefix>
                                                        <span class="material-icons search-icon">search</span>
                                                    </template>
                                                </a-input>
                                            </div>

                                            <div class="assignees-selection">
                                                <div v-for="user in filteredFollowerUsers" :key="user._id" class="assignee-container">
                                                    <div
                                                        @click="toggleFollowerSelection(user._id)"
                                                        :style="{
                                                            border: isFollowerSelected(user._id) ? '2px solid #47499d' : '2px solid white',
                                                            borderRadius: '50%',
                                                            backgroundColor: 'white',
                                                            zIndex: isFollowerSelected(user._id) ? 10 : 5
                                                        }"
                                                        :class="['avatar-container', {'selected': isFollowerSelected(user._id)}]"
                                                    >
                                                        <Avatar
                                                            style="cursor: pointer"
                                                            :size="40"
                                                            :key="1"
                                                            :username="user.name"
                                                            :src="user.gravatar"
                                                            v-tippy="{
                                                                followCursor: true,
                                                                placement: 'bottom-end',
                                                            }"
                                                            :content="user.name"
                                                        />
                                                    </div>
                                                    <div class="assignee-name">
                                                        {{ user.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Oluşturan -->
                                    <div v-show="activeFilterTab === 'createdBy'" class="filter-tab-pane">
                                        <div class="filter-options assignee-options">
                                            <div class="assignees-info">
                                                <h4>Görevi Oluşturan Seçimi</h4>
                                                <p class="assignees-description">
                                                    Görevi oluşturan kişi veya sisteme göre filtreleme yapabilirsiniz.
                                                    İstediğiniz kullanıcıları veya sistem türlerini seçerek, görevleri filtreleyebilirsiniz.
                                                </p>
                                            </div>

                                            <div class="creator-section">
                                                <h5 class="creator-section-title">Sistem Tarafından Oluşturulanlar</h5>
                                                <div class="creator-types">
                                                    <div v-for="createdByType in createdByTypes" :key="createdByType.type"
                                                        class="creator-type-container"
                                                        @click="toggleCreatedBySelection(createdByType.type)">
                                                        <div
                                                            :style="{
                                                                border: isCreatedBySelected(createdByType.type) ? '2px solid #47499d' : '2px solid transparent',
                                                                borderRadius: '50%',
                                                                backgroundColor: createdByType.color,
                                                                zIndex: isCreatedBySelected(createdByType.type) ? 10 : 5
                                                            }"
                                                            :class="['creator-avatar', {'selected': isCreatedBySelected(createdByType.type)}]"
                                                        >
                                                            <div class="system-avatar">
                                                                <span class="material-icons" style="color: white; font-size: 22px;">{{ createdByType.icon }}</span>
                                                            </div>
                                                            <div class="creator-hover-effect"></div>
                                                        </div>
                                                        <div class="creator-name">
                                                            {{ createdByType.label }}
                                                        </div>
                                                        <div class="creator-description">{{ createdByType.description }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="creator-section">
                                                <h5 class="creator-section-title">Kullanıcılar Tarafından Oluşturulanlar</h5>

                                                <div class="creator-search">
                                                    <a-input
                                                        v-model="creatorSearchQuery"
                                                        placeholder="Kullanıcı ara..."
                                                        class="creator-search-input"
                                                    >
                                                        <template #prefix>
                                                            <span class="material-icons search-icon">search</span>
                                                        </template>
                                                    </a-input>
                                                </div>

                                                <div class="assignees-selection creator-users">
                                                    <div v-for="user in filteredCreatorUsers" :key="user._id"
                                                        class="assignee-container creator-user-item"
                                                        @click="toggleCreatedBySelection(user._id)">
                                                        <div
                                                            :style="{
                                                                border: isCreatedBySelected(user._id) ? '2px solid #47499d' : '2px solid transparent',
                                                                borderRadius: '50%',
                                                                backgroundColor: 'white',
                                                                zIndex: isCreatedBySelected(user._id) ? 10 : 5
                                                            }"
                                                            :class="['avatar-container', {'selected': isCreatedBySelected(user._id)}]"
                                                        >
                                                            <Avatar
                                                                style="cursor: pointer"
                                                                :size="40"
                                                                :key="1"
                                                                :username="user.name"
                                                                :src="user.gravatar"
                                                                v-tippy="{
                                                                    followCursor: true,
                                                                    placement: 'bottom-end',
                                                                    content: user.name
                                                                }"
                                                            />
                                                            <div class="creator-hover-effect"></div>
                                                        </div>
                                                        <div class="assignee-name">
                                                            {{ user.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Tarih aralığı -->
                                    <div v-show="activeFilterTab === 'dateRange'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="date-range-info">
                                                <h4>Oluşturulma Tarihine Göre Filtrele</h4>
                                                <p class="date-range-description">
                                                    Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için başlangıç ve bitiş tarihlerini belirleyin.
                                                    Bu filtre, görevlerin oluşturulma tarihine (createdAt) göre filtreleme yapar.
                                                </p>
                                            </div>

                                            <div class="date-quick-filters">
                                                <a-button @click="setDateFilterToday" class="quick-filter-btn today-btn">
                                                    <span class="material-icons">today</span>
                                                    <span>Bugün</span>
                                                </a-button>
                                                <a-button @click="setDateFilterThisWeek" class="quick-filter-btn week-btn">
                                                    <span class="material-icons">view_week</span>
                                                    <span>Bu Hafta</span>
                                                </a-button>
                                                <a-button @click="setDateFilterThisMonth" class="quick-filter-btn month-btn">
                                                    <span class="material-icons">calendar_today</span>
                                                    <span>Bu Ay</span>
                                                </a-button>
                                            </div>

                                            <div class="date-range-picker-container">
                                                <div class="date-range-icon">
                                                    <span class="material-icons">date_range</span>
                                                </div>
                                                <a-range-picker
                                                    style="width: 100%"
                                                    v-model="selectedDateRange"
                                                    @click.native.stop
                                                    @change="handleDateRangeChange"
                                                    :placeholder="['Başlangıç Tarihi', 'Bitiş Tarihi']"
                                                    :showTime="false"
                                                    format="DD/MM/YYYY"
                                                    class="custom-date-picker"
                                                    :key="`creation-date-picker-${renderKey}`"
                                                />
                                            </div>

                                            <div class="date-hint" v-if="selectedDateRange && selectedDateRange.length === 2">
                                                <div class="date-chip">
                                                    <span class="material-icons">event</span>
                                                    <span>{{ formatDateDisplay(selectedDateRange[0]) }} - {{ formatDateDisplay(selectedDateRange[1]) }}</span>
                                                </div>
                                            </div>

                                            <div class="date-info-card">
                                                <div class="date-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Tarih Filtresi Hakkında</span>
                                                </div>
                                                <p class="date-info-text">
                                                    Tarih filtresi, görevlerin oluşturulma tarihine göre sonuçları sınırlandırır.
                                                    Böylece belirli bir zaman diliminde oluşturulmuş görevleri kolayca bulabilirsiniz.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Başlangıç Tarihi -->
                                    <div v-show="activeFilterTab === 'startDateRange'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="date-range-info">
                                                <h4>Başlangıç Tarihine Göre Filtrele</h4>
                                                <p class="date-range-description">
                                                    Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için başlangıç tarihini belirleyin.
                                                    Bu filtre, görevlerin başlangıç tarihine (startDate) göre filtreleme yapar.
                                                </p>
                                            </div>

                                            <div class="date-quick-filters">
                                                <a-button
                                                    @click="setStartDateFilterToday"
                                                    class="quick-filter-btn today-btn"
                                                >
                                                    <span class="material-icons">today</span>
                                                    <span>Bugün</span>
                                                </a-button>
                                                <a-button
                                                    @click="setStartDateFilterThisWeek"
                                                    class="quick-filter-btn week-btn"
                                                >
                                                    <span class="material-icons">view_week</span>
                                                    <span>Bu Hafta</span>
                                                </a-button>
                                                <a-button
                                                    @click="setStartDateFilterThisMonth"
                                                    class="quick-filter-btn month-btn"
                                                >
                                                    <span class="material-icons">calendar_today</span>
                                                    <span>Bu Ay</span>
                                                </a-button>
                                            </div>

                                            <div class="date-range-picker-container">
                                                <div class="date-range-icon">
                                                    <span class="material-icons">date_range</span>
                                                </div>
                                                <a-range-picker
                                                    style="width: 100%"
                                                    v-model="localStartDateRange"
                                                    @click.native.stop
                                                    @change="handleStartDateRangeChange"
                                                    :placeholder="['Başlangıç', 'Bitiş']"
                                                    :showTime="false"
                                                    format="DD/MM/YYYY"
                                                    class="custom-date-picker"
                                                    :key="`start-date-picker-${renderKey}`"
                                                />
                                            </div>

                                            <div class="date-hint" v-if="localStartDateRange && localStartDateRange.length === 2">
                                                <div class="date-chip">
                                                    <span class="material-icons">event</span>
                                                    <span>{{ formatDateDisplay(localStartDateRange[0]) }} - {{ formatDateDisplay(localStartDateRange[1]) }}</span>
                                                </div>
                                            </div>

                                            <div class="date-info-card">
                                                <div class="date-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Tarih Filtresi Hakkında</span>
                                                </div>
                                                <p class="date-info-text">
                                                    Tarih filtresi, görevlerin başlangıç tarihine göre sonuçları sınırlandırır.
                                                    Böylece belirli bir zaman aralığında başlayacak olan görevleri kolayca bulabilirsiniz.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Bitiş Tarihi -->
                                    <div v-show="activeFilterTab === 'endDateRange'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="date-range-info">
                                                <h4>Bitiş Tarihine Göre Filtrele</h4>
                                                <p class="date-range-description">
                                                    Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için bitiş tarihini belirleyin.
                                                    Bu filtre, görevlerin bitiş tarihine (endDate) göre filtreleme yapar.
                                                </p>
                                            </div>

                                            <div class="date-quick-filters">
                                                <a-button
                                                    @click="setEndDateFilterToday"
                                                    class="quick-filter-btn today-btn"
                                                >
                                                    <span class="material-icons">today</span>
                                                    <span>Bugün</span>
                                                </a-button>
                                                <a-button
                                                    @click="setEndDateFilterThisWeek"
                                                    class="quick-filter-btn week-btn"
                                                >
                                                    <span class="material-icons">view_week</span>
                                                    <span>Bu Hafta</span>
                                                </a-button>
                                                <a-button
                                                    @click="setEndDateFilterThisMonth"
                                                    class="quick-filter-btn month-btn"
                                                >
                                                    <span class="material-icons">calendar_today</span>
                                                    <span>Bu Ay</span>
                                                </a-button>
                                            </div>

                                            <div class="date-range-picker-container">
                                                <div class="date-range-icon">
                                                    <span class="material-icons">date_range</span>
                                                </div>
                                                <a-range-picker
                                                    style="width: 100%"
                                                    v-model="localEndDateRange"
                                                    @click.native.stop
                                                    @change="handleEndDateRangeChange"
                                                    :placeholder="['Başlangıç', 'Bitiş']"
                                                    :showTime="false"
                                                    format="DD/MM/YYYY"
                                                    class="custom-date-picker"
                                                    :key="`end-date-picker-${renderKey}`"
                                                />
                                            </div>

                                            <div class="date-hint" v-if="localEndDateRange && localEndDateRange.length === 2">
                                                <div class="date-chip">
                                                    <span class="material-icons">event</span>
                                                    <span>{{ formatDateDisplay(localEndDateRange[0]) }} - {{ formatDateDisplay(localEndDateRange[1]) }}</span>
                                                </div>
                                            </div>

                                            <div class="date-info-card">
                                                <div class="date-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Tarih Filtresi Hakkında</span>
                                                </div>
                                                <p class="date-info-text">
                                                    Tarih filtresi, görevlerin bitiş tarihine göre sonuçları sınırlandırır.
                                                    Böylece belirli bir zaman aralığında bitecek olan görevleri kolayca bulabilirsiniz.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Süresi Dolan Görevler -->
                                    <div v-show="activeFilterTab === 'overdue'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="overdue-info">
                                                <h4>Süresi Dolan Görevler</h4>
                                                <p class="overdue-description-text">
                                                    Teslim tarihi geçmiş ve hala tamamlanmamış görevleri filtreleyebilirsiniz.
                                                    Bu filtre aktif olduğunda, sadece süresi dolan görevler görüntülenecektir.
                                                </p>
                                            </div>

                                            <div class="overdue-card">
                                                <div class="overdue-card-header">
                                                    <div class="overdue-icon-wrapper">
                                                        <span class="material-icons overdue-icon">alarm</span>
                                                    </div>
                                                    <div class="overdue-title">Süresi dolan görevleri göster</div>
                                                    <a-checkbox
                                                        :checked="showOverdue"
                                                        @change="e => toggleOverdueFilter(e.target.checked)"
                                                        class="overdue-checkbox"
                                                    />
                                                </div>
                                                <div class="overdue-card-body">
                                                    <p class="overdue-detail">
                                                        Teslim tarihi geçmiş ve hala tamamlanmamış görevler, bu filtre aktif olduğunda görüntülenecektir.
                                                        Bu görevler genellikle ekibinizin en kısa sürede ilgilenmesi gereken görevlerdir.
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="overdue-info-card">
                                                <div class="overdue-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Önemli Bilgi</span>
                                                </div>
                                                <p class="overdue-info-text">
                                                    Süresi dolan görevler, teslim tarihi geçtiği halde tamamlanmamış görevlerdir.
                                                    Bu görevler, ekibinizin dikkatini çekmesi gereken önemli işleri gösterir.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Güncellenme Tarihi -->
                                    <div v-show="activeFilterTab === 'updateAt'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="date-range-info">
                                                <h4>Güncellenme Tarihine Göre Filtrele</h4>
                                                <p class="date-range-description">
                                                    Seçtiğiniz tarih aralığında güncellenmiş görevleri filtrelemek için başlangıç ve bitiş tarihlerini belirleyin.
                                                    Bu filtre, görevlerin güncellenme tarihine (updatedAt) göre filtreleme yapar.
                                                </p>
                                            </div>

                                            <div class="date-quick-filters">
                                                <a-button @click="setUpdateAtFilterToday" class="quick-filter-btn today-btn">
                                                    <span class="material-icons">today</span>
                                                    <span>Bugün</span>
                                                </a-button>
                                                <a-button @click="setUpdateAtFilterThisWeek" class="quick-filter-btn week-btn">
                                                    <span class="material-icons">view_week</span>
                                                    <span>Bu Hafta</span>
                                                </a-button>
                                                <a-button @click="setUpdateAtFilterThisMonth" class="quick-filter-btn month-btn">
                                                    <span class="material-icons">calendar_today</span>
                                                    <span>Bu Ay</span>
                                                </a-button>
                                            </div>

                                            <div class="date-range-picker-container">
                                                <div class="date-range-icon">
                                                    <span class="material-icons">date_range</span>
                                                </div>
                                                <a-range-picker
                                                    style="width: 100%"
                                                    v-model="localUpdateAtRange"
                                                    @click.native.stop
                                                    @change="handleUpdateAtRangeChange"
                                                    :placeholder="['Başlangıç', 'Bitiş']"
                                                    :showTime="false"
                                                    format="DD/MM/YYYY"
                                                    class="custom-date-picker"
                                                    :key="`update-at-picker-${renderKey}`"
                                                />
                                            </div>

                                            <div class="date-hint" v-if="localUpdateAtRange && localUpdateAtRange.length === 2">
                                                <div class="date-chip">
                                                    <span class="material-icons">event</span>
                                                    <span>{{ formatDateDisplay(localUpdateAtRange[0]) }} - {{ formatDateDisplay(localUpdateAtRange[1]) }}</span>
                                                </div>
                                            </div>

                                            <div class="date-info-card">
                                                <div class="date-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Tarih Filtresi Hakkında</span>
                                                </div>
                                                <p class="date-info-text">
                                                    Tarih filtresi, görevlerin son güncellenme tarihine göre sonuçları sınırlandırır.
                                                    Böylece belirli bir zaman aralığında güncellenmiş görevleri kolayca bulabilirsiniz.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Etiketler -->
                                    <div v-show="activeFilterTab === 'tags'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="tags-info">
                                                <h4>Görev Etiketleri</h4>
                                                <p class="tags-description-text">
                                                    Görevleri etiketlerine göre filtreleyebilirsiniz.
                                                    Seçtiğiniz etiketlere sahip görevler görüntülenecektir.
                                                </p>
                                            </div>

                                            <div class="tags-search">
                                                <a-input
                                                    v-model="tagSearchQuery"
                                                    placeholder="Etiket ara..."
                                                    class="tag-search-input"
                                                >
                                                    <template #prefix>
                                                        <span class="material-icons search-icon">search</span>
                                                    </template>
                                                </a-input>
                                            </div>

                                            <div class="tags-selection" v-if="filteredTags.length > 0">
                                                <div v-for="tag in filteredTags" :key="tag._id"
                                                    class="tag-card"
                                                    @click="toggleTagSelection(tag._id)">
                                                    <div class="tag-color" :style="{ backgroundColor: tag.color }"></div>
                                                    <div class="tag-info">
                                                        <div class="tag-name">{{ tag.name }}</div>
                                                        <div class="tag-desc" v-if="tag.description">{{ tag.description }}</div>
                                                    </div>
                                                    <a-checkbox
                                                        :checked="isTagSelected(tag._id)"
                                                        @click.stop
                                                        @change="e => toggleTagSelection(tag._id, e.target.checked)"
                                                        class="tag-checkbox"
                                                    />
                                                </div>
                                            </div>

                                            <div class="tags-loading" v-else-if="isTagsLoading">
                                                <a-spin />
                                                <p>Etiketler yükleniyor...</p>
                                            </div>

                                            <div class="tags-empty" v-else>
                                                <div class="tags-empty-icon">
                                                    <span class="material-icons">label_off</span>
                                                </div>
                                                <p class="tags-empty-text">{{ tagSearchQuery ? 'Arama kriterlerine uygun etiket bulunamadı.' : 'Henüz hiç etiket oluşturulmamış.' }}</p>
                                            </div>

                                            <div class="tags-info-card">
                                                <div class="tags-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Etiketler Hakkında</span>
                                                </div>
                                                <p class="tags-info-text">
                                                    Etiketler, görevleri kategorize etmenize ve daha kolay bulmanıza yardımcı olur.
                                                    Birden fazla etiket seçerseniz, seçilen etiketlerden herhangi birine sahip görevler gösterilecektir.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Durum -->
                                    <div v-show="activeFilterTab === 'status'" class="filter-tab-pane">
                                        <div class="filter-options">
                                            <div class="pipeline-info">
                                                <h4>Pipeline Durumu Seçimi</h4>
                                                <p class="pipeline-description-text">
                                                    Görevleri pipeline durumlarına göre filtreleyebilirsiniz.
                                                    İstediğiniz pipeline'ları seçerek, sadece o aşamalardaki görevleri görebilirsiniz.
                                                </p>
                                            </div>

                                            <div class="pipeline-search">
                                                <a-input
                                                    v-model="pipelineSearchQuery"
                                                    placeholder="Pipeline ara..."
                                                    class="pipeline-search-input"
                                                >
                                                    <template #prefix>
                                                        <span class="material-icons search-icon">search</span>
                                                    </template>
                                                </a-input>
                                            </div>

                                            <div class="pipelines-selection" v-if="filteredPipelines.length > 0">
                                                <div v-for="pipeline in filteredPipelines" :key="pipeline._id"
                                                    :class="['pipeline-card', { 'selected': isPipelineSelected(pipeline._id) }]"
                                                    :style="isPipelineSelected(pipeline._id) ? { borderColor: pipeline.color || '#47499d' } : {}"
                                                    @click="togglePipelineSelection(pipeline._id)">
                                                    <div class="pipeline-color" :style="{ backgroundColor: pipeline.color || '#47499d' }"></div>
                                                    <div class="pipeline-info">
                                                        <div class="pipeline-name">{{ pipeline.name }}</div>
                                                        <div class="pipeline-order">Sıra: {{ pipeline.order }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="pipelines-loading" v-else-if="isPipelinesLoading">
                                                <a-spin />
                                                <p>Pipeline'lar yükleniyor...</p>
                                            </div>

                                            <div class="pipelines-empty" v-else>
                                                <div class="pipelines-empty-icon">
                                                    <span class="material-icons">view_column</span>
                                                </div>
                                                <p class="pipelines-empty-text">{{ pipelineSearchQuery ? 'Arama kriterlerine uygun pipeline bulunamadı.' : 'Henüz hiç pipeline oluşturulmamış.' }}</p>
                                            </div>

                                            <div class="pipelines-info-card">
                                                <div class="pipelines-info-header">
                                                    <span class="material-icons info-icon">info</span>
                                                    <span>Pipeline'lar Hakkında</span>
                                                </div>
                                                <p class="pipelines-info-text">
                                                    Pipeline'lar, görevlerin hangi aşamada olduğunu gösterir.
                                                    Birden fazla pipeline seçerseniz, seçilen pipeline'lardan herhangi birinde bulunan görevler gösterilecektir.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="filter-actions">
                                <a-button type="link" @click="resetFilters">Filtreleri temizle</a-button>
                                <a-button type="primary" @click="applyFilters">Uygula</a-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showOperations && showBatchOperations && !!batchOperationItems.length" class="batch-operation">
                <div class="batch-count">{{ batchOperationItems.length }} seçili</div>
                
                <div class="batch-actions">
                    <div class="batch-btn" @click="changeCheckedTasks({ target: { checked: !checkedAllTasks } })">
                        <a-checkbox
                            class="kanban-checkbox"
                            :indeterminate="checkedAnyTasks"
                            :checked="checkedAllTasks"
                            @change="changeCheckedTasks"
                            @click.stop
                        />
                    </div>

                    <div class="batch-btn" @click="$emit('change-stage')">
                        <span class="material-icons">table_chart</span>
                        <span>{{ $t("task.changeStage") }}</span>
                    </div>

                    <div class="batch-btn" @click="$emit('delete-tasks')">
                        <span class="material-icons">delete</span>
                        <span>{{ $t("chatbotv2.delete") }}</span>
                    </div>

                    <div v-if="canCloseTasks" class="batch-btn close-task-btn" @click="$emit('close-tasks')">
                        <span class="material-icons">check_circle</span>
                        <span>Görevi Kapat</span>
                    </div>
                </div>
            </div>

            <slot name="right-buttons"></slot>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";
import moment from "moment";
import LowIcon from "../svg/task/LowIcon.vue";
import LowestIcon from "../svg/task/LowestIcon.vue";
import MediumIcon from "../svg/task/MediumIcon.vue";
import HighIcon from "../svg/task/HighIcon.vue";
import HighestIcon from "../svg/task/HighestIcon.vue";

export default {
    name: "TaskFilterBar",
    components: {
        Avatar,
        LowIcon,
        LowestIcon,
        MediumIcon,
        HighIcon,
        HighestIcon,
    },
    props: {
        assignees: {
            type: Array,
            default: () => [],
        },
        owners: {
            type: Array,
            default: () => [],
        },
        followers: {
            type: Array,
            default: () => [],
        },
        createdBy: {
            type: Array,
            default: () => [],
        },
        workflowId: {
            type: String,
            default: null,
        },
        checkedItems: {
            type: Object,
            default: () => ({}),
        },
        checkedAllTasks: {
            type: Boolean,
            default: false,
        },
        checkedAnyTasks: {
            type: Boolean,
            default: false,
        },
        batchOperationItems: {
            type: Array,
            default: () => [],
        },
        showBatchOperations: {
            type: Boolean,
            default: false,
        },
        showOperations: {
            type: Boolean,
            default: false,
        },
        showOverdue: {
            type: Boolean,
            default: false,
        },
        searchQuery: {
            type: [String, null],
            default: ''
        },
        dateRange: {
            type: Array,
            default: () => null
        },
        startDateRange: {
            type: Array,
            default: () => null
        },
        endDateRange: {
            type: Array,
            default: () => null
        },
        selectedPriorities: {
            type: Array,
            default: () => []
        },
        selectedTags: {
            type: Array,
            default: () => []
        },
        updateAtRange: {
            type: Array,
            default: () => null
        },
        canCloseTasks: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            priorities: [
                { value: "lowest", label: "Lowest", icon: "LowestIcon", description: "En Düşük Öncelik" },
                { value: "low", label: "Low", icon: "LowIcon", description: "Düşük Öncelik" },
                { value: "medium", label: "Medium", icon: "MediumIcon", description: "Orta Öncelik" },
                { value: "high", label: "High", icon: "HighIcon", description: "Yüksek Öncelik" },
                { value: "highest", label: "Highest", icon: "HighestIcon", description: "En Yüksek Öncelik" },
            ],
            createdByTypes: [
                { type: "api", label: "API", icon: "code", color: "#52c41a", description: "API tarafından oluşturulan görevler" },
                { type: "chatbot", label: "Chatbot", icon: "smart_toy", color: "#f5222d", description: "Chatbot tarafından oluşturulan görevler" },
                { type: "automation", label: "Otomasyon", icon: "psychology", color: "#722ed1", description: "Otomasyon tarafından oluşturulan görevler" }
            ],
            isFilterModalOpen: false,
            activeFilterTab: "priorities",
            selectedDateRange: null,
            renderKey: 0,
            localSelectedPriorities: [],
            localSelectedCreatedBy: [],
            isTagsLoading: false,
            tags: [],
            localSelectedTags: [],
            searchString: '',
            isRemainingUsersOpen: false,
            ownerSearchQuery: '',
            followerSearchQuery: '',
            creatorSearchQuery: '',
            tagSearchQuery: '',
            remainingUsersSearchQuery: '',
            localSearchQuery: '',
            pipelineSearchQuery: '',
            pipelines: [],
            localSelectedPipelines: [],
            isPipelinesLoading: false,
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            usersAvatar: (state) => state.user.users.data,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        visibleUsers() {
            return this.filteredUsersAvatar.filter((_, index) => index < 5);
        },
        remainingUsers() {
            return this.filteredUsersAvatar.filter((_, index) => index >= 5);
        },
        filteredUsersAvatar() {
            const workflowKeys = Object.keys(this.workflows);
            const workflows = workflowKeys.map((key) => this.workflows[key]);
            const selectedWorkflows = workflows.filter((workflow) => workflow._id === this.workflowId);

            let usersList;
            if (
                selectedWorkflows.length === 0 ||
                !selectedWorkflows[0] ||
                !selectedWorkflows[0].visibility ||
                selectedWorkflows[0].visibility.users.length === 0
            ) {
                usersList = this.usersAvatar;
            } else {
                const usersFromSelectedWorkflows = selectedWorkflows.map((workflow) => workflow.visibility.users);
                const users = usersFromSelectedWorkflows.flat();
                usersList = users.map((userId) => this.users[userId]).filter(Boolean);
            }

            if (this.user && this.user._id) {
                const currentUser = usersList.find(user => user._id === this.user._id);
                if (currentUser) {
                    const otherUsers = usersList.filter(user => user._id !== this.user._id);
                    return [currentUser, ...otherUsers];
                }
            }

            return usersList;
        },
        filterTabs() {
            const tabs = [
                { key: "priorities", title: "Öncelik" },
                // { key: "assignees", title: "Göreve Atanan" },
                { key: "owners", title: "Görev Sahibi" },
                { key: "followers", title: "Görev Takipçileri" },
                { key: "createdBy", title: "Oluşturan" },
                { key: "dateRange", title: "Oluşturulma Tarihi" },
                { key: "updateAt", title: "Güncellenme Tarihi" },
                { key: "startDateRange", title: "Başlangıç Tarihi" },
                { key: "endDateRange", title: "Bitiş Tarihi" },
                { key: "tags", title: "Etiketler" },
                { key: "overdue", title: "Süresi Dolan Görevler" },
            ];

            if (this.workflowId) {
                tabs.push({ key: "status", title: "Durum" });
            }

            return tabs;
        },
        activeFilterCount() {
            let count = 0;

            if (this.localSelectedPriorities.length > 0) {
                count++;
            }

            if (this.selectedDateRange && this.selectedDateRange.length === 2) {
                count++;
            }

            if (this.startDateRange && this.startDateRange.length === 2) {
                count++;
            }

            if (this.endDateRange && this.endDateRange.length === 2) {
                count++;
            }

            if (this.updateAtRange && this.updateAtRange.length === 2) {
                count++;
            }

            if (this.showOverdue) {
                count++;
            }

            if (this.localSelectedTags && this.localSelectedTags.length > 0) {
                count++;
            }

            if (this.assignees && this.assignees.length > 0) {
                count++;
            }

            if (this.owners && this.owners.length > 0) {
                count++;
            }

            if (this.followers && this.followers.length > 0) {
                count++;
            }

            if (this.createdBy && this.createdBy.length > 0) {
                count++;
            }

            if (this.localSelectedPipelines && this.localSelectedPipelines.length > 0) {
                count++;
            }

            return count;
        },
        localStartDateRange: {
            get() {
                if (this.startDateRange && Array.isArray(this.startDateRange) && this.startDateRange.length === 2) {
                    try {
                        return [moment(this.startDateRange[0]), moment(this.startDateRange[1])];
                    } catch (e) {
                        console.error('startDateRange dönüştürme hatası:', e);
                        return null;
                    }
                }
                return null;
            },
            set(value) {
                if (value && Array.isArray(value) && value.length === 2) {
                    this.$emit('update:startDateRange', [
                        value[0].format('YYYY-MM-DD'),
                        value[1].format('YYYY-MM-DD')
                    ]);
                } else {
                    this.$emit('update:startDateRange', null);
                }
            }
        },
        localEndDateRange: {
            get() {
                if (this.endDateRange && Array.isArray(this.endDateRange) && this.endDateRange.length === 2) {
                    try {
                        return [moment(this.endDateRange[0]), moment(this.endDateRange[1])];
                    } catch (e) {
                        console.error('endDateRange dönüştürme hatası:', e);
                        return null;
                    }
                }
                return null;
            },
            set(value) {
                if (value && Array.isArray(value) && value.length === 2) {
                    this.$emit('update:endDateRange', [
                        value[0].format('YYYY-MM-DD'),
                        value[1].format('YYYY-MM-DD')
                    ]);
                } else {
                    this.$emit('update:endDateRange', null);
                }
            }
        },
        selectedDateRangeValue: {
            get() {
                if (this.dateRange && Array.isArray(this.dateRange) && this.dateRange.length === 2) {
                    try {
                        return [moment(this.dateRange[0]), moment(this.dateRange[1])];
                    } catch (e) {
                        console.error('dateRange dönüştürme hatası:', e);
                        return null;
                    }
                }
                return this.selectedDateRange;
            },
            set(value) {
                this.selectedDateRange = value;
            }
        },
        localShowOverdue: {
            get() {
                return this.showOverdue;
            },
            set(value) {
                this.$emit('update:showOverdue', value);
            }
        },
        localUpdateAtRange: {
            get() {
                if (this.updateAtRange && Array.isArray(this.updateAtRange) && this.updateAtRange.length === 2) {
                    try {
                        return [moment(this.updateAtRange[0]), moment(this.updateAtRange[1])];
                    } catch (e) {
                        console.error('updateAtRange dönüştürme hatası:', e);
                        return null;
                    }
                }
                return null;
            },
            set(value) {
                if (value && Array.isArray(value) && value.length === 2) {
                    this.$emit('update:updateAtRange', [
                        value[0].format('YYYY-MM-DD'),
                        value[1].format('YYYY-MM-DD')
                    ]);
                } else {
                    this.$emit('update:updateAtRange', null);
                }
            }
        },
        filteredOwnerUsers() {
            if (!this.ownerSearchQuery) {
                return this.filteredUsersAvatar;
            }
            const query = this.ownerSearchQuery.toLowerCase();
            return this.filteredUsersAvatar.filter(user =>
                user.name.toLowerCase().includes(query)
            );
        },
        filteredFollowerUsers() {
            if (!this.followerSearchQuery) {
                return this.filteredUsersAvatar;
            }
            const query = this.followerSearchQuery.toLowerCase();
            return this.filteredUsersAvatar.filter(user =>
                user.name.toLowerCase().includes(query)
            );
        },
        filteredCreatorUsers() {
            if (!this.creatorSearchQuery) {
                return this.filteredUsersAvatar;
            }
            const query = this.creatorSearchQuery.toLowerCase();
            return this.filteredUsersAvatar.filter(user =>
                user.name.toLowerCase().includes(query)
            );
        },
        filteredTags() {
            if (!this.tagSearchQuery) {
                return this.tags;
            }
            const query = this.tagSearchQuery.toLowerCase();
            return this.tags.filter(tag =>
                tag.name.toLowerCase().includes(query) ||
                (tag.description && tag.description.toLowerCase().includes(query))
            );
        },
        filteredRemainingUsers() {
            if (!this.remainingUsersSearchQuery) {
                return this.remainingUsers;
            }
            const query = this.remainingUsersSearchQuery.toLowerCase();
            return this.remainingUsers.filter(user =>
                user.name.toLowerCase().includes(query)
            );
        },
        filteredPipelines() {
            if (!this.pipelineSearchQuery) {
                return this.pipelines;
            }
            const query = this.pipelineSearchQuery.toLowerCase();
            return this.pipelines.filter(pipeline =>
                pipeline.name.toLowerCase().includes(query) ||
                (pipeline.description && pipeline.description.toLowerCase().includes(query))
            );
        },
    },
    methods: {
        ...mapActions({
            getTags: "tag/getTags",
            getPiplineName: "tasks/getPiplineName",
        }),
        handleSearch() {
            this.$emit('search', this.localSearchQuery);

            const filters = {
                assignees: this.assignees,
                owners: this.owners,
                followers: this.followers,
                createdBy: this.createdBy,
                showOverdue: this.showOverdue,
                selectedPriorities: this.localSelectedPriorities,
                selectedTags: this.localSelectedTags,
                selectedPipelines: this.localSelectedPipelines,
                searchQuery: this.localSearchQuery,
                dateRange: this.selectedDateRange && this.selectedDateRange.length === 2 ?
                    this.formatDateRange(this.selectedDateRange) : null,
                startDateRange: this.localStartDateRange && this.localStartDateRange.length === 2 ?
                    this.formatDateRange(this.localStartDateRange) : null,
                endDateRange: this.localEndDateRange && this.localEndDateRange.length === 2 ?
                    this.formatDateRange(this.localEndDateRange) : null,
                updateAtRange: this.localUpdateAtRange && this.localUpdateAtRange.length === 2 ?
                    this.formatDateRange(this.localUpdateAtRange) : null
            };
            this.$emit('apply-filters', filters);
        },
        clearSearch() {
            this.localSearchQuery = '';
            this.$emit('search', '');

            const filters = {
                assignees: this.assignees,
                owners: this.owners,
                followers: this.followers,
                createdBy: this.createdBy,
                showOverdue: this.showOverdue,
                selectedPriorities: this.localSelectedPriorities,
                selectedTags: this.localSelectedTags,
                selectedPipelines: this.localSelectedPipelines,
                searchQuery: '',
                dateRange: this.selectedDateRange && this.selectedDateRange.length === 2 ?
                    this.formatDateRange(this.selectedDateRange) : null,
                startDateRange: this.localStartDateRange && this.localStartDateRange.length === 2 ?
                    this.formatDateRange(this.localStartDateRange) : null,
                endDateRange: this.localEndDateRange && this.localEndDateRange.length === 2 ?
                    this.formatDateRange(this.localEndDateRange) : null,
                updateAtRange: this.localUpdateAtRange && this.localUpdateAtRange.length === 2 ?
                    this.formatDateRange(this.localUpdateAtRange) : null
            };
            this.$emit('apply-filters', filters);
        },
        toggleUserSelection(userId) {
            const index = this.assignees.indexOf(userId);
            if (index > -1) {
                this.assignees.splice(index, 1);
            } else {
                this.assignees.push(userId);
            }
            this.$emit('update:assignees', [...this.assignees]);

            const filters = {
                assignees: this.assignees,
                owners: this.owners,
                followers: this.followers,
                createdBy: this.createdBy,
                showOverdue: this.showOverdue,
                selectedPriorities: this.localSelectedPriorities,
                selectedTags: this.localSelectedTags,
                selectedPipelines: this.localSelectedPipelines,
                searchQuery: this.localSearchQuery,
                dateRange: this.selectedDateRange && this.selectedDateRange.length === 2 ?
                    this.formatDateRange(this.selectedDateRange) : null,
                startDateRange: this.localStartDateRange && this.localStartDateRange.length === 2 ?
                    this.formatDateRange(this.localStartDateRange) : null,
                endDateRange: this.localEndDateRange && this.localEndDateRange.length === 2 ?
                    this.formatDateRange(this.localEndDateRange) : null,
                updateAtRange: this.localUpdateAtRange && this.localUpdateAtRange.length === 2 ?
                    this.formatDateRange(this.localUpdateAtRange) : null
            };
            this.$emit('apply-filters', filters);
        },
        isUserSelected(userId) {
            return this.assignees.includes(userId);
        },
        toggleOwnerSelection(userId) {
            const index = this.owners.indexOf(userId);
            if (index > -1) {
                this.owners.splice(index, 1);
            } else {
                this.owners.push(userId);
            }
        },
        isOwnerSelected(userId) {
            return this.owners.includes(userId);
        },
        toggleFollowerSelection(userId) {
            const index = this.followers.indexOf(userId);
            if (index > -1) {
                this.followers.splice(index, 1);
            } else {
                this.followers.push(userId);
            }
        },
        isFollowerSelected(userId) {
            return this.followers.includes(userId);
        },
        changeCheckedTasks(e) {
            this.$emit("check-all-tasks", e.target.checked);
        },
        toggleOverdueFilter(checked) {
            this.showOverdue = checked;
        },
        onSearch(value) {
            this.$emit("search", value);
        },
        handleClickOutside(event) {
            if (event.target.closest('.ant-calendar-picker-container')) {
                return;
            }

            if (this.isFilterModalOpen && this.$refs.filterPanel && !this.$refs.filterPanel.contains(event.target)
                && !event.target.closest(".custom-filter-button")) {
                this.closeFilterModal();
            }

            if (this.isRemainingUsersOpen &&
                this.$refs.customDropdown &&
                !this.$refs.customDropdown.contains(event.target) &&
                !event.target.closest(".remaining-indicator")) {
                this.closeRemainingUsers();
            }
        },
        toggleFilterModal() {
            this.isFilterModalOpen = !this.isFilterModalOpen;

            if (this.isFilterModalOpen) {
                this.activeFilterTab = "priorities";
            }
        },
        closeFilterModal() {
            this.isFilterModalOpen = false;
        },
        resetFilters() {
            console.log('TaskFilterBar - Filtreler temizleniyor');

            this.localSearchQuery = '';
            this.$emit('update:showOverdue', false);
            this.selectedDateRange = null;
            this.localStartDateRange = null;
            this.localEndDateRange = null;
            this.localUpdateAtRange = null;
            this.localSelectedPriorities = [];
            this.localSelectedTags = [];
            this.localSelectedPipelines = [];
            this.pipelineSearchQuery = '';

            const filters = {
                assignees: [],
                owners: [],
                followers: [],
                createdBy: [],
                showOverdue: false,
                selectedPriorities: [],
                selectedTags: [],
                selectedPipelines: [],
                searchQuery: '',
                dateRange: null,
                startDateRange: null,
                endDateRange: null,
                updateAtRange: null
            };

            this.$emit('apply-filters', filters);

            this.closeFilterModal();
        },
        resetAllFilters() {
            console.log('TaskFilterBar - Tüm filtreler otomatik sıfırlanıyor');

            this.localSearchQuery = '';
            this.selectedDateRange = null;
            this.localStartDateRange = null;
            this.localEndDateRange = null;
            this.localUpdateAtRange = null;
            this.localSelectedPriorities = [];
            this.localSelectedTags = [];
            this.localSelectedPipelines = [];
            this.pipelineSearchQuery = '';

            this.$emit('update:showOverdue', false);
            this.$emit('update:assignees', []);
            this.$emit('update:owners', []);
            this.$emit('update:followers', []);
            this.$emit('update:createdBy', []);
            this.$emit('update:selectedPriorities', []);
            this.$emit('update:selectedTags', []);
            this.$emit('update:searchQuery', '');
            this.$emit('update:dateRange', null);
            this.$emit('update:startDateRange', null);
            this.$emit('update:endDateRange', null);
            this.$emit('update:updateAtRange', null);

            const filters = {
                assignees: [],
                owners: [],
                followers: [],
                createdBy: [],
                showOverdue: false,
                selectedPriorities: [],
                selectedTags: [],
                selectedPipelines: [],
                searchQuery: '',
                dateRange: null,
                startDateRange: null,
                endDateRange: null,
                updateAtRange: null
            };

            this.$emit('apply-filters', filters);
        },
        applyFilters() {
            console.log('TaskFilterBar - Filtreler uygulanıyor');

            if (this.selectedDateRange && this.selectedDateRange.length === 2) {
                this.$emit('update:dateRange', this.formatDateRange(this.selectedDateRange));
            } else {
                this.$emit('update:dateRange', null);
            }

            const filters = {
                assignees: this.assignees,
                owners: this.owners,
                followers: this.followers,
                createdBy: this.createdBy,
                showOverdue: this.showOverdue,
                selectedPriorities: this.localSelectedPriorities,
                selectedTags: this.localSelectedTags,
                selectedPipelines: this.localSelectedPipelines,
                searchQuery: this.localSearchQuery,
                dateRange: this.selectedDateRange && this.selectedDateRange.length === 2 ?
                    this.formatDateRange(this.selectedDateRange) : null,
                startDateRange: this.localStartDateRange && this.localStartDateRange.length === 2 ?
                    this.formatDateRange(this.localStartDateRange) : null,
                endDateRange: this.localEndDateRange && this.localEndDateRange.length === 2 ?
                    this.formatDateRange(this.localEndDateRange) : null,
                updateAtRange: this.localUpdateAtRange && this.localUpdateAtRange.length === 2 ?
                    this.formatDateRange(this.localUpdateAtRange) : null
            };

            console.log('TaskFilterBar - Gönderilen filtreler:', filters);

            this.$emit('apply-filters', filters);

            this.closeFilterModal();
        },

        formatDateRange(dateRange) {
            if (!dateRange || dateRange.length !== 2) return null;

            const start = dateRange[0];
            const end = dateRange[1];

            const startFormatted = typeof start === 'object' && start._isAMomentObject ?
                start.format('YYYY-MM-DD') :
                typeof start === 'string' ? start :
                typeof start.format === 'function' ? start.format('YYYY-MM-DD') :
                moment(start).format('YYYY-MM-DD');

            const endFormatted = typeof end === 'object' && end._isAMomentObject ?
                end.format('YYYY-MM-DD') :
                typeof end === 'string' ? end :
                typeof end.format === 'function' ? end.format('YYYY-MM-DD') :
                moment(end).format('YYYY-MM-DD');

            return [startFormatted, endFormatted];
        },
        togglePriorityInPanel(value, checked) {
            const newPriorities = [...this.localSelectedPriorities];
            if (checked) {
                newPriorities.push(value);
            } else {
                newPriorities.splice(newPriorities.indexOf(value), 1);
            }
            this.localSelectedPriorities = newPriorities;
        },
        handleDateRangeChange(dates) {
            if (dates && dates.length === 2) {
                this.selectedDateRange = [dates[0], dates[1]];
            } else {
                this.selectedDateRange = null;
            }
        },
        handleStartDateRangeChange(dates) {
            if (dates && dates.length === 2) {
                this.localStartDateRange = [dates[0], dates[1]];
            } else {
                this.localStartDateRange = null;
            }
        },
        clearPriorities() {
            this.localSelectedPriorities = [];
        },
        setDateFilterToday() {
            const today = moment();
            const todayStart = today.clone().startOf('day');
            const todayEnd = today.clone().endOf('day');
            this.selectedDateRange = [todayStart, todayEnd];

            this.renderKey++;
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        setDateFilterThisWeek() {
            const today = moment();
            const weekStart = today.clone().startOf('week');
            const weekEnd = today.clone().endOf('week');
            this.selectedDateRange = [weekStart, weekEnd];

            this.renderKey++;
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        setDateFilterThisMonth() {
            const today = moment();
            const monthStart = today.clone().startOf('month');
            const monthEnd = today.clone().endOf('month');
            this.selectedDateRange = [monthStart, monthEnd];

            this.renderKey++;
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        setStartDateFilterToday() {
            const today = moment();
            const todayStart = today.clone().startOf('day');
            const todayEnd = today.clone().endOf('day');

            this.localStartDateRange = [todayStart, todayEnd];

            this.renderKey++;
        },
        setStartDateFilterThisWeek() {
            const today = moment();
            const weekStart = today.clone().startOf('week');
            const weekEnd = today.clone().endOf('week');

            this.localStartDateRange = [weekStart, weekEnd];

            this.renderKey++;
        },
        setStartDateFilterThisMonth() {
            const today = moment();
            const monthStart = today.clone().startOf('month');
            const monthEnd = today.clone().endOf('month');

            this.localStartDateRange = [monthStart, monthEnd];

            this.renderKey++;
        },
        setEndDateFilterToday() {
            const today = moment();
            const todayStart = today.clone().startOf('day');
            const todayEnd = today.clone().endOf('day');

            this.localEndDateRange = [todayStart, todayEnd];

            this.renderKey++;
        },
        setEndDateFilterThisWeek() {
            const today = moment();
            const weekStart = today.clone().startOf('week');
            const weekEnd = today.clone().endOf('week');

            this.localEndDateRange = [weekStart, weekEnd];

            this.renderKey++;
        },
        setEndDateFilterThisMonth() {
            const today = moment();
            const monthStart = today.clone().startOf('month');
            const monthEnd = today.clone().endOf('month');

            this.localEndDateRange = [monthStart, monthEnd];

            this.renderKey++;
        },
        setUpdateAtFilterToday() {
            const today = moment();
            const todayStart = today.clone().startOf('day');
            const todayEnd = today.clone().endOf('day');

            this.localUpdateAtRange = [todayStart, todayEnd];

            this.renderKey++;
        },
        setUpdateAtFilterThisWeek() {
            const today = moment();
            const weekStart = today.clone().startOf('week');
            const weekEnd = today.clone().endOf('week');

            this.localUpdateAtRange = [weekStart, weekEnd];

            this.renderKey++;
        },
        setUpdateAtFilterThisMonth() {
            const today = moment();
            const monthStart = today.clone().startOf('month');
            const monthEnd = today.clone().endOf('month');

            this.localUpdateAtRange = [monthStart, monthEnd];

            this.renderKey++;
        },
        toggleRemainingUsers() {
            this.isRemainingUsersOpen = !this.isRemainingUsersOpen;
        },
        closeRemainingUsers() {
            this.isRemainingUsersOpen = false;
        },
        toggleUserSelectionAndClose(userId) {
            this.toggleUserSelection(userId);
            this.closeRemainingUsers();
        },
        hasActiveFilterInTab(tabKey) {
            switch (tabKey) {
                case 'priorities':
                    return this.localSelectedPriorities.length > 0;
                case 'assignees':
                    return this.assignees.length > 0;
                case 'owners':
                    return this.owners.length > 0;
                case 'followers':
                    return this.followers.length > 0;
                case 'createdBy':
                    return this.createdBy.length > 0;
                case 'dateRange':
                    return this.selectedDateRange && this.selectedDateRange.length === 2;
                case 'startDateRange':
                    return this.localStartDateRange && this.localStartDateRange.length === 2;
                case 'endDateRange':
                    return this.localEndDateRange && this.localEndDateRange.length === 2;
                case 'updateAt':
                    return this.localUpdateAtRange && this.localUpdateAtRange.length === 2;
                case 'tags':
                    return this.localSelectedTags.length > 0;
                case 'overdue':
                    return this.showOverdue;
                case 'status':
                    return this.localSelectedPipelines.length > 0;
                default:
                    return false;
            }
        },
        updateDateRangeAndApply(name, start, end) {
            if (name === 'creation') {
                this.selectedDateRange = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
            } else if (name === 'start') {
                this._localStartDateRange = [start, end];
                this.renderKey++;
            } else if (name === 'end') {
                this._localEndDateRange = [start, end];
                this.renderKey++;
            }

            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        toggleUserSelectionInPanel(userId) {
            const index = this.assignees.indexOf(userId);
            if (index > -1) {
                this.assignees.splice(index, 1);
            } else {
                this.assignees.push(userId);
            }
            this.$emit('update:assignees', [...this.assignees]);

            const filters = {
                assignees: this.assignees,
                owners: this.owners,
                followers: this.followers,
                createdBy: this.createdBy,
                showOverdue: this.showOverdue,
                selectedPriorities: this.localSelectedPriorities,
                selectedTags: this.localSelectedTags,
                selectedPipelines: this.localSelectedPipelines,
                searchQuery: this.localSearchQuery,
                dateRange: this.selectedDateRange && this.selectedDateRange.length === 2 ?
                    this.formatDateRange(this.selectedDateRange) : null,
                startDateRange: this.localStartDateRange && this.localStartDateRange.length === 2 ?
                    this.formatDateRange(this.localStartDateRange) : null,
                endDateRange: this.localEndDateRange && this.localEndDateRange.length === 2 ?
                    this.formatDateRange(this.localEndDateRange) : null,
                updateAtRange: this.localUpdateAtRange && this.localUpdateAtRange.length === 2 ?
                    this.formatDateRange(this.localUpdateAtRange) : null
            };
            this.$emit('apply-filters', filters);
        },
        toggleCreatedBySelection(createdByValue) {
            const index = this.createdBy.indexOf(createdByValue);
            if (index > -1) {
                this.createdBy.splice(index, 1);
            } else {
                this.createdBy.push(createdByValue);
            }
        },
        isCreatedBySelected(createdByValue) {
            return this.createdBy.includes(createdByValue);
        },
        toggleCreatedByInPanel(value, checked) {
            const newCreatedBy = [...this.localSelectedCreatedBy];
            if (checked) {
                newCreatedBy.push(value);
            } else {
                newCreatedBy.splice(newCreatedBy.indexOf(value), 1);
            }
            this.localSelectedCreatedBy = newCreatedBy;
            this.$emit('update:createdBy', [...this.localSelectedCreatedBy]);
        },
        formatDateDisplay(dateString) {
            if (!dateString) return '';
            if (typeof dateString === 'object' && dateString._isAMomentObject) {
                return dateString.format('DD MMM YYYY');
            }
            return moment(dateString).format('DD MMM YYYY');
        },
        async fetchTags() {
            this.isTagsLoading = true;
            try {
                this.tags = await this.getTags("task");
            } catch (error) {
                console.error("Etiketleri getirirken bir hata oluştu:", error);
            } finally {
                this.isTagsLoading = false;
            }
        },
        toggleTagSelection(tagId, checked) {
            if (checked === undefined) {
                const index = this.localSelectedTags.indexOf(tagId);
                if (index > -1) {
                    this.localSelectedTags.splice(index, 1);
                } else {
                    this.localSelectedTags.push(tagId);
                }
            } else {
                const newTags = [...this.localSelectedTags];
                if (checked) {
                    newTags.push(tagId);
                } else {
                    const index = newTags.indexOf(tagId);
                    if (index > -1) {
                        newTags.splice(index, 1);
                    }
                }
                this.localSelectedTags = newTags;
            }
        },
        isTagSelected(tagId) {
            return this.localSelectedTags.includes(tagId);
        },
        handleEndDateRangeChange(dates) {
            if (dates && dates.length === 2) {
                this.localEndDateRange = [dates[0], dates[1]];
            } else {
                this.localEndDateRange = null;
            }
        },
        handleUpdateAtRangeChange(dates) {
            if (dates && dates.length === 2) {
                this.localUpdateAtRange = [dates[0], dates[1]];
            } else {
                this.localUpdateAtRange = null;
            }
        },
        async fetchPipelines() {
            this.isPipelinesLoading = true;
            try {
                this.pipelines = await this.getPiplineName(this.workflowId);
            } catch (error) {
                console.error("Pipeline'ları getirirken bir hata oluştu:", error);
            } finally {
                this.isPipelinesLoading = false;
            }
        },
        togglePipelineSelection(pipelineId, checked) {
            if (checked === undefined) {
                const index = this.localSelectedPipelines.indexOf(pipelineId);
                if (index > -1) {
                    this.localSelectedPipelines.splice(index, 1);
                } else {
                    this.localSelectedPipelines.push(pipelineId);
                }
            } else {
                const newPipelines = [...this.localSelectedPipelines];
                if (checked) {
                    newPipelines.push(pipelineId);
                } else {
                    const index = newPipelines.indexOf(pipelineId);
                    if (index > -1) {
                        newPipelines.splice(index, 1);
                    }
                }
                this.localSelectedPipelines = newPipelines;
            }
        },
        isPipelineSelected(pipelineId) {
            return this.localSelectedPipelines.includes(pipelineId);
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        this.fetchTags();
        this.renderKey = 0;

        this.$nextTick(() => {
            this.$forceUpdate();
        });
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        workflows: {
            deep: true,
            handler() {
                // updateRouteParams metodu parent'ta olduğu için emit ile bildir
                if (typeof this.updateRouteParams === 'function') {
                this.updateRouteParams();
                }
            },
        },
        dateRange: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.selectedDateRange = newVal;
                } else {
                    this.selectedDateRange = null;
                }
            }
        },
        startDateRange: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.renderKey++;
                }
            }
        },
        endDateRange: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.renderKey++;
                }
            }
        },
        updateAtRange: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.renderKey++;
                }
            }
        },
        selectedPriorities: {
            immediate: true,
            handler(newVal) {
                this.localSelectedPriorities = newVal ? [...newVal] : [];
            }
        },
        createdBy: {
            immediate: true,
            handler(newVal) {
                this.localSelectedCreatedBy = newVal ? [...newVal] : [];
            }
        },
        selectedTags: {
            immediate: true,
            handler(newVal) {
                this.localSelectedTags = newVal ? [...newVal] : [];
            }
        },
        showOverdue: {
            immediate: true,
            handler(newVal) {
                this.localShowOverdue = newVal;
            }
        },
        searchQuery: {
            immediate: true,
            handler(newVal) {
                this.localSearchQuery = newVal || '';
            }
        },
        activeFilterTab: {
            handler(newVal) {
                if (newVal === 'status') {
                    this.fetchPipelines();
                }
            }
        },
        workflowId: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && oldVal !== undefined) {
                    this.resetAllFilters();
                }
            },
            immediate: false
        }
    },
};
</script>

<style lang="scss" scoped>
#task-filter-bar {
    width: 100%;

    .filter-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        background-color: var(--color-bg-neutral-default);
        border-bottom: 1px solid var(--color-border-default);
        min-height: 50px;
        width: 100%;
    }

    .popover-scroll-container {
        max-height: 300px;
        overflow-y: auto;
        padding-right: 10px;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #47499d;
        }
    }

    .filter-toolbar {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .search-bar {
        max-width: 400px;
        width: 100%;

        .modern-search-input {
            border-radius: 8px;
            transition: all 0.3s ease;

            &:hover, &:focus {
                box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
            }

            .ant-input {
                padding-left: 40px;
                height: 40px;
                font-size: 14px;

                &:focus {
                    border-color: #47499d;
                }
            }
        }

        .search-icon {
            color: #8c8c8c;
            font-size: 20px;
            transition: color 0.3s ease;
        }

        .clear-icon {
            color: #8c8c8c;
            font-size: 18px;
            cursor: pointer;
            transition: color 0.3s ease;

            &:hover {
                color: #47499d;
            }
        }

        :deep(.ant-input-affix-wrapper) {
            &:hover, &:focus {
                .search-icon {
                    color: #47499d;
                }
            }
        }
    }

    .avatar-container {
        position: relative;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    .avatar-container.selected {
        z-index: 10;
        box-shadow: 0 2px 6px rgba(71, 73, 157, 0.2);
    }

    .avatar-container:hover {
        transform: scale(1.15);
        z-index: 12 !important;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    }

    .avatar-wrapper {
        display: inline-flex;
    }

    .avatar-container.remaining-indicator {
        position: relative;
        transition: all 0.3s ease;

        &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 10px rgba(71, 73, 157, 0.35);
        }

        &.active {
            transform: scale(1.1);
            background-color: #3f418d;
            box-shadow: 0 4px 12px rgba(71, 73, 157, 0.4);

            &:after {
                content: '';
                position: absolute;
                bottom: -8px;
                right: 10px;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid white;
                z-index: 1001;
            }
        }
    }

    .batch-operation {
        display: flex;
        align-items: center;
        gap: 12px;

        .batch-count {
            font-size: 13px;
            font-weight: 600;
            color: #47499d;
            padding: 4px 12px;
            background-color: rgba(71, 73, 157, 0.1);
            border-radius: 12px;
        }

        .batch-actions {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .batch-btn {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 6px 12px;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            border: 1px solid #e8e8e8;
            background-color: white;
            font-size: 13px;
            font-weight: 500;

            .material-icons {
                font-size: 18px;
            }

            .kanban-checkbox {
                margin: 0;

                :deep(.ant-checkbox-inner) {
                    border-radius: 4px;
                }

                :deep(.ant-checkbox-checked .ant-checkbox-inner) {
                    background-color: #47499d;
                    border-color: #47499d;
                }

                :deep(.ant-checkbox-indeterminate .ant-checkbox-inner::after) {
                    background-color: #47499d;
                }
            }

            &:hover {
                border-color: #d0d0d0;
                background-color: #fafafa;
            }

            &.close-task-btn {
                color: #52c41a;

                .material-icons {
                    color: #52c41a;
                }

                &:hover {
                    border-color: #52c41a;
                    background-color: rgba(82, 196, 26, 0.05);
                }
            }
        }
    }

    .filter-button {
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;

        .custom-filter-button {
            display: flex;
            align-items: center;
            padding: 6px 12px;
            border-radius: 20px;
            border: 1px solid #e0e0e0;
            background-color: #ffffff;
            transition: all 0.3s ease;
            height: auto;
            position: relative;

            .button-text {
                font-weight: 500;
                font-size: 14px;
                color: #555;
            }

            .material-icons {
                color: #777;
                transition: color 0.3s ease;
            }

            .filter-indicator {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #47499d;
                margin-left: 5px;
            }

            &:hover {
                border-color: #bdbdbd;
                background-color: #f9f9f9;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);

                .material-icons {
                    color: #555;
                }
            }

            &.active-filter {
                background-color: #f0f2ff;
                border-color: #47499d;

                .material-icons {
                    color: #47499d;
                }

                .button-text {
                    color: #47499d;
                    font-weight: 600;
                }

                &:hover {
                    background-color: #e6ebff;
                    box-shadow: 0 2px 7px rgba(71, 73, 157, 0.1);
                }
            }
        }
    }

    .filter-panel {
        position: absolute;
        top: calc(100% + 8px);
        left: -300px;
        width: 800px;
        max-width: 90vw;
        background-color: white;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        animation: slideDown 0.2s ease-out;
        overflow: hidden;
        margin-top: 2px;

        @keyframes slideDown {
            from {
                opacity: 0;
                transform: translateY(-10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .filter-panel-arrow {
            position: absolute;
            top: -10px;
            left: 80px;
            width: 20px;
            height: 10px;
            overflow: hidden;

            &:after {
                content: '';
                position: absolute;
                width: 10px;
                height: 10px;
                background-color: white;
                transform: translateX(5px) translateY(5px) rotate(45deg);
                top: 0;
                left: 0;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            }
        }

        .filter-panel-content {
            padding: 20px;

            .filter-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                border-bottom: 1px solid #f0f0f0;
                padding-bottom: 12px;

                h3 {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin: 0;
                }

                .filter-header-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    .reset-button {
                        color: #47499d;
                        font-size: 13px;
                        padding: 0 8px;

                        &:hover {
                            color: darken(#47499d, 10%);
                            background: rgba(71, 73, 157, 0.05);
                        }
                    }

                    .apply-button {
                        background-color: #47499d;
                        border-color: #47499d;
                        font-weight: 500;
                        font-size: 13px;
                        height: 28px;
                        padding: 0 12px;

                        &:hover {
                            background-color: darken(#47499d, 10%);
                            border-color: darken(#47499d, 10%);
                        }
                    }

                    .close-button {
                        background: none;
                        border: none;
                        padding: 4px;
                        cursor: pointer;
                        color: #888;
                        transition: color 0.2s;
                        margin-left: 4px;

                        &:hover {
                            color: #47499d;
                        }
                    }
                }
            }

            .filter-tab-layout {
                display: flex;
                gap: 20px;
                min-height: 400px;
                max-height: 450px;

                .filter-tabs {
                    flex: 0 0 200px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    border-right: 1px solid #f0f0f0;
                    padding-right: 15px;
                    max-height: 450px;
                    overflow: auto;

                    .filter-tab {
                        padding: 10px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        font-weight: 500;
                        text-align: left;
                        position: relative;
                        padding-left: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        &:before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 0;
                            bottom: 0;
                            width: 3px;
                            background-color: transparent;
                            transition: background-color 0.3s ease;
                        }

                        .tab-filter-indicator {
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            background-color: #52c41a;
                            margin-left: 8px;
                            display: inline-block;
                            position: relative;
                            animation: pulse 1.5s infinite;
                        }

                        @keyframes pulse {
                            0% {
                                box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
                            }
                            70% {
                                box-shadow: 0 0 0 5px rgba(82, 196, 26, 0);
                            }
                            100% {
                                box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
                            }
                        }

                        &.active {
                            color: #47499d;
                            background-color: #f5f6ff;
                            font-weight: 600;

                            &:before {
                                background-color: #47499d;
                            }

                            .tab-filter-indicator {
                                background-color: #47499d;
                                animation: pulseActive 1.5s infinite;
                            }

                            @keyframes pulseActive {
                                0% {
                                    box-shadow: 0 0 0 0 rgba(71, 73, 157, 0.4);
                                }
                                70% {
                                    box-shadow: 0 0 0 5px rgba(71, 73, 157, 0);
                                }
                                100% {
                                    box-shadow: 0 0 0 0 rgba(71, 73, 157, 0);
                                }
                            }
                        }

                        &:hover {
                            background-color: #f5f5f5;
                        }
                    }
                }

                .filter-tab-content {
                    flex: 1;
                    overflow-y: auto;
                    padding-right: 10px;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 3px;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #ccc;
                        border-radius: 3px;
                    }

                    &::-webkit-scrollbar-thumb:hover {
                        background: #47499d;
                    }

                    .filter-tab-pane {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding: 10px 0;

                        .filter-options {
                            margin-bottom: 20px;
                            display: flex;
                            flex-direction: column;
                            gap: 12px;

                            :deep(.ant-checkbox-wrapper) {
                                margin-left: 0;
                                font-size: 14px;

                                &:hover {
                                    color: #47499d;
                                }
                            }

                            :deep(.ant-checkbox-checked .ant-checkbox-inner) {
                                background-color: #47499d;
                                border-color: #47499d;
                            }

                            .overdue-checkbox {
                                :deep(.ant-checkbox-checked .ant-checkbox-inner) {
                                    background-color: #1890ff;
                                    border-color: #1890ff;
                                }

                                :deep(.ant-checkbox-inner) {
                                    border-radius: 4px;
                                    width: 18px;
                                    height: 18px;

                                    &:after {
                                        left: 5px;
                                    }
                                }

                                :deep(.ant-checkbox-wrapper:hover .ant-checkbox-inner),
                                :deep(.ant-checkbox:hover .ant-checkbox-inner),
                                :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
                                    border-color: #1890ff;
                                }
                            }

                            .overdue-checkbox-container {
                                display: flex;
                                align-items: center;
                                gap: 6px;
                                cursor: pointer;
                            }

                            :deep(.ant-select) {
                                .ant-select-selector {
                                    border-radius: 6px;

                                    &:hover {
                                        border-color: #47499d;
                                    }
                                }
                            }

                            :deep(.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector) {
                                border-color: #47499d;
                                box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                            }

                            .priority-info {
                                margin-bottom: 20px;

                                h4 {
                                    font-size: 16px;
                                    font-weight: 600;
                                    color: #333;
                                    margin-bottom: 10px;
                                }

                                .priority-description-text {
                                    color: #666;
                                    font-size: 13px;
                                    line-height: 1.5;
                                    margin: 0;
                                }
                            }

                            .priority-selection {
                                display: flex;
                                flex-direction: column;
                                gap: 12px;
                                margin-bottom: 20px;
                            }

                            .priority-card {
                                background-color: #f9f9f9;
                                border-radius: 8px;
                                border: 1px solid #eee;
                                overflow: hidden;
                                transition: all 0.3s ease;
                                cursor: pointer;

                                &:hover {
                                    transform: translateY(-2px);
                                    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
                                }

                                .priority-card-header {
                                    display: flex;
                                    align-items: center;
                                    padding: 12px 15px;
                                    position: relative;
                                    background-color: #fff;
                                    border-bottom: 1px solid #f0f0f0;

                                    &.selected {
                                        background-color: rgba(71, 73, 157, 0.1);
                                        border-color: rgba(71, 73, 157, 0.2);
                                    }

                                    .priority-icon {
                                        width: 20px;
                                        height: 20px;
                                        margin-right: 12px;
                                    }

                                    .priority-label {
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: #333;
                                        flex: 1;
                                    }

                                    .priority-checkbox {
                                        position: absolute;
                                        right: 15px;
                                        top: 50%;
                                        transform: translateY(-50%);
                                    }
                                }

                                .priority-card-body {
                                    padding: 10px 15px;

                                    .priority-description {
                                        font-size: 12px;
                                        color: #666;
                                        margin: 0;
                                    }
                                }
                            }

                            .priority-info-card {
                                background-color: #f0f8ff;
                                border: 1px solid #d1e9ff;
                                border-radius: 8px;
                                padding: 15px;
                                margin-top: 10px;
                                box-shadow: 0 2px 6px rgba(0,0,0,0.03);

                                .priority-info-header {
                                    display: flex;
                                    align-items: center;
                                    gap: 8px;
                                    font-weight: 600;
                                    color: #0078d4;
                                    margin-bottom: 10px;

                                    .info-icon {
                                        font-size: 18px;
                                        color: #0078d4;
                                    }
                                }

                                .priority-info-text {
                                    color: #555;
                                    font-size: 13px;
                                    line-height: 1.6;
                                    margin: 0;
                                }
                            }
                        }

                        .assignee-options {
                            .assignees-info {
                                margin-bottom: 20px;

                                h4 {
                                    font-size: 16px;
                                    font-weight: 600;
                                    color: #333;
                                    margin-bottom: 10px;
                                }

                                .assignees-description {
                                    color: #666;
                                    font-size: 13px;
                                    line-height: 1.5;
                                    margin: 0;
                                }
                            }

                            .assignees-selection {
                                display: flex;
                                flex-wrap: wrap;
                                gap: 20px;

                                .assignee-container {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    width: 80px;
                                    transition: all 0.3s ease;

                                    &:hover {
                                        transform: translateY(-3px);
                                    }

                                    .avatar-container {
                                        margin-bottom: 8px;
                                    }

                                    .assignee-name {
                                        text-align: center;
                                        font-size: 12px;
                                        color: #666;
                                        max-width: 100%;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .filter-actions {
                display: none; /* Eski bölümü gizle */
                justify-content: flex-end;
                gap: 10px;
                margin-top: 15px;
                padding-top: 15px;
                border-top: 1px solid #f0f0f0;

                :deep(.ant-btn-primary) {
                    background-color: #47499d;
                    border-color: #47499d;
                    font-weight: 500;

                    &:hover {
                        background-color: darken(#47499d, 10%);
                        border-color: darken(#47499d, 10%);
                    }
                }

                :deep(.ant-btn-link) {
                    color: #47499d;

                    &:hover {
                        color: darken(#47499d, 10%);
                    }
                }
            }
        }
    }

    .system-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .date-range-info {
        margin-bottom: 20px;

        h4 {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
        }

        .date-range-description {
            color: #666;
            font-size: 13px;
            line-height: 1.5;
            margin: 0;
        }
    }

    .date-range-picker-container {
        position: relative;
        margin-bottom: 15px;
        background-color: #f9f9f9;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;

        &:hover {
            background-color: #f5f5f5;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
        }

        .date-range-icon {
            position: absolute;
            left: 25px;
            top: 50%;
            transform: translateY(-50%);
            color: #47499d;

            .material-icons {
                font-size: 20px;
            }
        }

        :deep(.custom-date-picker) {
            .ant-calendar-picker-input {
                padding-left: 30px;
                border-radius: 6px;
                border: 1px solid #e0e0e0;
                transition: all 0.3s ease;

                &:hover, &:focus {
                    border-color: #47499d;
                    box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.1);
                }
            }
        }
    }

    .date-hint {
        margin-bottom: 15px;

        .date-chip {
            display: inline-flex;
            align-items: center;
            padding: 4px 12px;
            background-color: rgba(71, 73, 157, 0.1);
            border-radius: 16px;
            font-size: 13px;
            color: #47499d;

            .material-icons {
                font-size: 16px;
                margin-right: 5px;
            }
        }
    }

    .date-info-card, .creator-info-card {
        background-color: #f0f8ff;
        border: 1px solid #d1e9ff;
        border-radius: 8px;
        padding: 15px;
        margin-top: 10px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.03);

        .date-info-header, .creator-info-header {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            color: #0078d4;
            margin-bottom: 10px;

            .info-icon {
                font-size: 18px;
                color: #0078d4;
            }
        }

        .date-info-text, .creator-info-text {
            color: #555;
            font-size: 13px;
            line-height: 1.6;
            margin: 0;
        }
    }

    .creator-section {
        margin-bottom: 24px;

        .creator-section-title {
            font-size: 14px;
            font-weight: 600;
            color: #555;
            margin-bottom: 12px;
            padding-bottom: 6px;
            border-bottom: 1px solid #eee;
        }
    }

    .creator-types {
        display: flex;
        gap: 15px;
        margin-bottom: 15px;
        flex-wrap: wrap;

        .creator-type-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 110px;
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 15px 10px;
            transition: all 0.3s ease;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
            cursor: pointer;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
            }

            .creator-avatar {
                position: relative;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 10px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                transition: all 0.3s ease;

                &.selected {
                    transform: scale(1.1);
                    box-shadow: 0 3px 10px rgba(71, 73, 157, 0.3);
                }

                .creator-hover-effect {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border-radius: 50%;
                    background-color: rgba(255, 255, 255, 0.1);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                &:hover .creator-hover-effect {
                    opacity: 1;
                }
            }

            .creator-name {
                font-weight: 600;
                font-size: 13px;
                color: #444;
                margin-bottom: 4px;
                text-align: center;
            }

            .creator-description {
                font-size: 11px;
                color: #777;
                text-align: center;
                line-height: 1.3;
            }
        }
    }

    .creator-users {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .creator-user-item {
            width: 70px;
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 10px 5px;
            transition: all 0.3s ease;
            cursor: pointer;

            &:hover {
                transform: translateY(-3px);
                background-color: #f5f5f5;
            }

            .avatar-container {
                position: relative;
                margin-bottom: 6px;

                .creator-hover-effect {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border-radius: 50%;
                    background-color: rgba(255, 255, 255, 0.1);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                &:hover .creator-hover-effect {
                    opacity: 1;
                }

                &.selected {
                    transform: scale(1.1);
                    box-shadow: 0 3px 10px rgba(71, 73, 157, 0.3);
                }
            }
        }
    }

    .system-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .overdue-info {
        margin-bottom: 20px;

        h4 {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
        }

        .overdue-description-text {
            color: #666;
            font-size: 13px;
            line-height: 1.5;
            margin: 0;
        }
    }

    .overdue-card {
        background-color: #f9f9f9;
        border-radius: 8px;
        border: 1px solid #eee;
        overflow: hidden;
        margin-bottom: 20px;
        transition: all 0.3s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

        &:hover {
            background-color: #f5f5f5;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
        }

        .overdue-card-header {
            display: flex;
            align-items: center;
            padding: 15px;
            position: relative;
            background-color: #fff;
            border-bottom: 1px solid #f0f0f0;

            .overdue-icon-wrapper {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background-color: rgba(245, 34, 45, 0.1);
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;

                .overdue-icon {
                    color: #f5222d;
                    font-size: 22px;
                }
            }

            .overdue-title {
                font-weight: 600;
                font-size: 15px;
                color: #333;
                flex: 1;
            }

            .overdue-checkbox {
                position: absolute;
                right: 15px;

                :deep(.ant-checkbox-checked .ant-checkbox-inner) {
                    background-color: #f5222d;
                    border-color: #f5222d;
                }

                :deep(.ant-checkbox-inner) {
                    border-radius: 4px;
                    width: 18px;
                    height: 18px;

                    &:after {
                        left: 5px;
                    }
                }

                :deep(.ant-checkbox-wrapper:hover .ant-checkbox-inner),
                :deep(.ant-checkbox:hover .ant-checkbox-inner),
                :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
                    border-color: #f5222d;
                }
            }
        }

        .overdue-card-body {
            padding: 15px;

            .overdue-detail {
                font-size: 13px;
                color: #666;
                margin: 0;
                line-height: 1.5;
            }
        }
    }

    .overdue-info-card {
        background-color: #fff7e6;
        border: 1px solid #ffe7ba;
        border-radius: 8px;
        padding: 15px;
        margin-top: 10px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.03);

        .overdue-info-header {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            color: #d48806;
            margin-bottom: 10px;

            .info-icon {
                font-size: 18px;
                color: #faad14;
            }
        }

        .overdue-info-text {
            color: #666;
            font-size: 13px;
            line-height: 1.6;
            margin: 0;
        }
    }

    .tag-card {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 6px;
        border: 1px solid #e8e8e8;
        padding: 10px 15px;
        margin-bottom: 10px;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
        }

        .tag-color {
            width: 16px;
            height: 16px;
            border-radius: 3px;
            margin-right: 12px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .tag-info {
            flex: 1;

            .tag-name {
                font-weight: 600;
                font-size: 14px;
                color: #333;
                margin-bottom: 2px;
            }

            .tag-desc {
                font-size: 12px;
                color: #666;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 300px;
            }
        }

        .tag-checkbox {
            margin-left: 10px;
        }
    }

    .tags-empty {
        text-align: center;
        padding: 30px 0;

        .tags-empty-icon {
            font-size: 40px;
            color: #ccc;
            margin-bottom: 10px;

            .material-icons {
                font-size: 40px;
            }
        }

        .tags-empty-text {
            color: #999;
            font-size: 14px;
        }
    }

    .tags-loading {
        text-align: center;
        padding: 30px 0;

        p {
            margin-top: 10px;
            color: #666;
        }
    }

    .tags-info-card {
        background-color: #f0f8ff;
        border: 1px solid #d1e9ff;
        border-radius: 8px;
        padding: 15px;
        margin-top: 20px;

        .tags-info-header {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            color: #0078d4;
            margin-bottom: 10px;

            .info-icon {
                font-size: 18px;
                color: #0078d4;
            }
        }

        .tags-info-text {
            color: #555;
            font-size: 13px;
            line-height: 1.6;
            margin: 0;
        }
    }

    .date-quick-filters {
        display: flex;
        gap: 12px;
        margin-bottom: 15px;
        justify-content: center;

        .quick-filter-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            background-color: transparent;
            color: #555;
            border-radius: 20px;
            padding: 5px 16px;
            font-weight: 500;
            border: 1px solid #dcdfe6;
            transition: all 0.25s ease;
            box-shadow: none;
            height: auto;

            .material-icons {
                font-size: 16px;
            }

            &:hover, &:focus {
                color: #47499d;
                border-color: #bfbfff;
                background-color: rgba(71, 73, 157, 0.05);
                transform: translateY(-1px);
                box-shadow: 0 2px 4px rgba(71, 73, 157, 0.1);
            }

            &:active {
                transform: translateY(0);
                box-shadow: none;
            }

            &.today-btn {
                .material-icons {
                    color: #52c41a;
                }
                &:hover {
                    border-color: #b7eb8f;
                    color: #52c41a;
                    background-color: rgba(82, 196, 26, 0.05);
                }
            }

            &.week-btn {
                .material-icons {
                    color: #1890ff;
                }
                &:hover {
                    border-color: #91d5ff;
                    color: #1890ff;
                    background-color: rgba(24, 144, 255, 0.05);
                }
            }

            &.month-btn {
                .material-icons {
                    color: #722ed1;
                }
                &:hover {
                    border-color: #d3adf7;
                    color: #722ed1;
                    background-color: rgba(114, 46, 209, 0.05);
                }
            }
        }
    }

    .custom-dropdown-container {
        position: relative;
        display: inline-block;
    }

    .custom-dropdown {
        position: absolute;
        background-color: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        z-index: 1000;
        top: calc(100% + 10px);
        right: -10px;
        width: 260px;
        max-height: 300px;
        padding: 0;
        margin-top: 5px;
        animation: dropdown-fade 0.2s ease;
        overflow: hidden;

        @keyframes dropdown-fade {
            from {
                opacity: 0;
                transform: translateY(-10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #47499d;
        }

        .dropdown-arrow {
            position: absolute;
            top: -8px;
            right: 20px;
            width: 16px;
            height: 16px;
            background-color: white;
            border-left: 1px solid #e0e0e0;
            border-top: 1px solid #e0e0e0;
            transform: rotate(45deg);
        }

        .dropdown-header {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 15px;
            border-bottom: 1px solid #f0f0f0;
            position: sticky;
            top: 0;
            background-color: white;
            z-index: 2;
            border-radius: 12px 12px 0 0;

            .dropdown-header-top {
                display: flex;
                justify-content: space-between;
                align-items: center;

                span {
                    font-weight: 600;
                    color: #333;
                    font-size: 14px;
                }

                .dropdown-close {
                    cursor: pointer;
                    background-color: #f5f5f5;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s;

                    &:hover {
                        background-color: #e9e9e9;
                    }

                    .material-icons {
                        font-size: 18px;
                        color: #666;
                    }
                }
            }

            .dropdown-search {
                .dropdown-search-input {
                    width: 100%;
                    border-radius: 6px;
                    transition: all 0.3s ease;

                    :deep(.ant-input) {
                        padding-left: 32px;
                        height: 32px;
                        font-size: 13px;
                        border-radius: 6px;

                        &:focus {
                            border-color: #47499d;
                            box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                        }
                    }

                    .search-icon {
                        color: #8c8c8c;
                        font-size: 16px;
                        transition: color 0.3s ease;
                    }

                    :deep(.ant-input-affix-wrapper) {
                        &:hover, &:focus {
                            .search-icon {
                                color: #47499d;
                            }
                        }
                    }
                }
            }
        }

        .dropdown-content {
            padding: 6px 0;
            max-height: calc(290px - 50px);
            overflow-y: auto;

            .dropdown-item {
                display: flex;
                align-items: center;
                padding: 8px 15px;
                cursor: pointer;
                transition: all 0.2s;
                position: relative;

                &:hover {
                    background-color: #f5f6ff;
                }

                .avatar-container {
                    margin-right: 10px;
                    transition: transform 0.2s ease;

                    &.selected {
                        transform: scale(1.05);
                    }
                }

                .dropdown-item-name {
                    font-size: 14px;
                    color: #333;
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .dropdown-item-check {
                    color: #47499d;
                    margin-left: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .material-icons {
                        font-size: 18px;
                    }
                }
            }
        }
    }

    .owner-search {
        margin-bottom: 20px;

        .owner-search-input {
            width: 100%;
            border-radius: 8px;
            transition: all 0.3s ease;

            :deep(.ant-input) {
                padding-left: 40px;
                height: 40px;
                font-size: 14px;
                border-radius: 8px;

                &:focus {
                    border-color: #47499d;
                    box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                }
            }

            .search-icon {
                color: #8c8c8c;
                font-size: 20px;
                transition: color 0.3s ease;
            }

            :deep(.ant-input-affix-wrapper) {
                &:hover, &:focus {
                    .search-icon {
                        color: #47499d;
                    }
                }
            }
        }
    }

    .follower-search {
        margin-bottom: 20px;

        .follower-search-input {
            width: 100%;
            border-radius: 8px;
            transition: all 0.3s ease;

            :deep(.ant-input) {
                padding-left: 40px;
                height: 40px;
                font-size: 14px;
                border-radius: 8px;

                &:focus {
                    border-color: #47499d;
                    box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                }
            }

            .search-icon {
                color: #8c8c8c;
                font-size: 20px;
                transition: color 0.3s ease;
            }

            :deep(.ant-input-affix-wrapper) {
                &:hover, &:focus {
                    .search-icon {
                        color: #47499d;
                    }
                }
            }
        }
    }

    .creator-search {
        margin-bottom: 20px;

        .creator-search-input {
            width: 100%;
            border-radius: 8px;
            transition: all 0.3s ease;

            :deep(.ant-input) {
                padding-left: 40px;
                height: 40px;
                font-size: 14px;
                border-radius: 8px;

                &:focus {
                    border-color: #47499d;
                    box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                }
            }

            .search-icon {
                color: #8c8c8c;
                font-size: 20px;
                transition: color 0.3s ease;
            }

            :deep(.ant-input-affix-wrapper) {
                &:hover, &:focus {
                    .search-icon {
                        color: #47499d;
                    }
                }
            }
        }
    }

    .tags-search {
        margin-bottom: 20px;

        .tag-search-input {
            width: 100%;
            border-radius: 8px;
            transition: all 0.3s ease;

            :deep(.ant-input) {
                padding-left: 40px;
                height: 40px;
                font-size: 14px;
                border-radius: 8px;

                &:focus {
                    border-color: #47499d;
                    box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                }
            }

            .search-icon {
                color: #8c8c8c;
                font-size: 20px;
                transition: color 0.3s ease;
            }

            :deep(.ant-input-affix-wrapper) {
                &:hover, &:focus {
                    .search-icon {
                        color: #47499d;
                    }
                }
            }
        }
    }

    .pipeline-info {

        h4 {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
        }

        .pipeline-description-text {
            color: #666;
            font-size: 13px;
            line-height: 1.5;
            margin: 0;
        }
    }

    .pipeline-search {
        margin-bottom: 20px;

        .pipeline-search-input {
            width: 100%;
            border-radius: 8px;
            transition: all 0.3s ease;

            :deep(.ant-input) {
                padding-left: 40px;
                height: 40px;
                font-size: 14px;
                border-radius: 8px;

                &:focus {
                    border-color: #47499d;
                    box-shadow: 0 0 0 2px rgba(71, 73, 157, 0.2);
                }
            }

            .search-icon {
                color: #8c8c8c;
                font-size: 20px;
                transition: color 0.3s ease;
            }

            :deep(.ant-input-affix-wrapper) {
                &:hover, &:focus {
                    .search-icon {
                        color: #47499d;
                    }
                }
            }
        }
    }

    .pipelines-selection {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-start;

        .pipeline-card {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            border-radius: 6px;
            border: 2px solid #e8e8e8;
            padding: 8px 6px;
            transition: all 0.3s ease;
            cursor: pointer;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
            width: 90px;
            min-height: 65px;
            position: relative;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
                border-color: #d0d0d0;
            }

            &.selected {
                background-color: rgba(0, 0, 0, 0.03);
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
            }

            .pipeline-color {
                width: 20px;
                height: 20px;
                border-radius: 4px;
                margin-bottom: 6px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
                flex-shrink: 0;
            }

            .pipeline-info {
                text-align: center;
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .pipeline-name {
                    font-weight: 600;
                    font-size: 11px;
                    color: #333;
                    margin-bottom: 2px;
                    line-height: 1.1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                .pipeline-order {
                    font-size: 9px;
                    color: #999;
                    font-style: italic;
                }
            }
        }
    }

    .pipelines-empty {
        text-align: center;
        padding: 30px 0;

        .pipelines-empty-icon {
            font-size: 40px;
            color: #ccc;
            margin-bottom: 10px;

            .material-icons {
                font-size: 40px;
            }
        }

        .pipelines-empty-text {
            color: #999;
            font-size: 14px;
        }
    }

    .pipelines-loading {
        text-align: center;
        padding: 30px 0;

        p {
            margin-top: 10px;
            color: #666;
        }
    }

    .pipelines-info-card {
        background-color: #f0f8ff;
        border: 1px solid #d1e9ff;
        border-radius: 8px;
        padding: 15px;
        margin-top: 20px;

        .pipelines-info-header {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            color: #0078d4;
            margin-bottom: 10px;

            .info-icon {
                font-size: 18px;
                color: #0078d4;
            }
        }

        .pipelines-info-text {
            color: #555;
            font-size: 13px;
            line-height: 1.6;
            margin: 0;
        }
    }
}
</style>
